<template>
    <MediaDefault v-bind="props" force-bem-block="slice-media--video" force-test-id-prefix="media-video">
        <template #media>
            <PrismicEmbed
                v-if="isFilled.embed(slice.primary.video)"
                :class="['slice-media--video__video', {'slice-media--video__video--compressed': slice.primary.mediaRatio}]"
                :field="slice.primary.video"
                data-testid="media-video-embed"
            />
        </template>
    </MediaDefault>
</template>

<script setup lang="ts">
    import {isFilled} from '@prismicio/helpers';
    import {getSliceComponentProps, PrismicEmbed} from '@prismicio/vue';
    import type {MediaSlice} from '@prismicio-types';
    import MediaDefault from './MediaDefault.vue';

    type MediaVideoInZone = Extract<MediaSlice, {variation: 'mediaVideo'}>;

    const props = defineProps(getSliceComponentProps<MediaVideoInZone>());
</script>
